module.exports = __webpack_public_path__ + "fonts/icons.260912d.eot";